import { IconButton, Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useReactFlow } from '@xyflow/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import {
  ApprovalBranchViewData,
  ApprovalBranchViewRowValues,
  ApprovalValues,
} from '../../../types';
import { convertToApprovalLevelNodes } from '../../ApproverLevels/utils';
import { setNodeScrollState } from '../../Conditions';
import { FormView } from '../AddApprovalBranchNode/FormView';

export const UpdateNode: React.FC<{
  approvalTypes: ApprovalSetupFlowCommonData | undefined;
  data: ApprovalBranchViewData;
}> = ({ approvalTypes, data }) => {
  const formMethods = useFormContext<ApprovalValues>();
  const { setNodes, setEdges } = useReactFlow();
  const [visibility, setVisibility] = useState(false);
  const calloutId = useId(`update-level-branch-${data.id}`);

  const handleUpdateBranch = (formFields: ApprovalBranchViewRowValues) => {
    formMethods.setValue(
      // @ts-ignore
      `approvalTrees.${data.levelIndex}.approvalBranches.${data.approverBranchIndex}`,
      formFields,
      {
        shouldDirty: true,
      }
    );

    const { nodes: modulatedNodes, edges: modulatedEdges } =
      convertToApprovalLevelNodes(
        // @ts-ignore
        formMethods.getValues('approvalTrees'),
        'vertical'
      );
    setNodes([...modulatedNodes]);
    setEdges([...modulatedEdges]);
    setNodeScrollState(true);
    setVisibility(false);
  };
    const handleUserRankUpdate = (newId: string) => {
      formMethods.setValue(
        // @ts-ignore

        `approvalTrees.${data.levelIndex}.approvalBranches.${data.approverBranchIndex}.userRank.id`,
        newId,
        { shouldDirty: true }
      );
    };

  return (
    <Stack>
      <IconButton
        id={calloutId}
        iconProps={{ iconName: 'PageHeaderEdit' }}
        onClick={() => {
          setNodeScrollState(false);
          setVisibility(true);
        }}
      />
      <FormView
        data={data}
        onSave={handleUpdateBranch}
        approvalTypes={approvalTypes}
        onClose={() => {
          setNodeScrollState(true);
          setVisibility(false);
        }}
        visibility={visibility}
        handleUserRankUpdate={handleUserRankUpdate}
      />
    </Stack>
  );
};
